import React from 'react'
import { appHistory } from '@core/Utils/routing/history'
import { MainContainer } from '@core/Components/Containers'
import { ContentHeader } from '@core/Components/ContentHeader'
import type { Campaign } from '@mobi/account/Areas/SignUp'
import { BetOffers } from './Components/BetOffers'
import { getRaceUrl } from '../helpers/getRaceUrl'
import { fetchCampaignsAsync } from '@core/State/UserAccount/async-signals'
import { openDeposit } from '@core/Areas/Deposit'

export const BetOfferPage: React.FC = () => {
  React.useEffect(() => {
    fetchCampaignsAsync()
  }, [])

  const handleCampaignClick = (campaign: Campaign) => {
    if (campaign.triggerType === 'AccountDepositTrigger' && campaign.isLive) openDeposit()
    else appHistory.push(getRaceUrl(campaign))
  }

  return (
    <MainContainer data-tid-bonus-detail-heading background='surface300'>
      <ContentHeader title='Bonuses' />
      <BetOffers handleCampaignClick={handleCampaignClick} />
    </MainContainer>
  )
}
